import { apiEndpoint } from '@/config';
import { fetcher } from '@/lib/swr';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
  CustomerSecretViewModel,
} from '@hidayahlab/academy-suite-corelib';
import useSWR from 'swr';
import { useGetCustomer } from './use-customer-api';

/**
 * 🚨 IMPORTANT NOTICE 🚨
 *
 * Only use customer secrets that are SAFE for client-side usage.
 *
 * If you are unsure whether a secret can be safely exposed,
 * STOP and confirm with the team before proceeding.
 */

export function useGetBunnyCdnLibraryId() {
  const { customer } = useGetCustomer();
  const customerId = customer?.id;

  const apiUrl = customerId
    ? `${apiEndpoint}/customer-secrets/customers/${customerId}/bunny-cdn-library-id`
    : null;

  const { data, error, isLoading } = useSWR<
    ApiSuccessResponse<CustomerSecretViewModel>,
    ApiErrorResponse
  >(apiUrl, (url: string) => fetcher(url));

  return {
    data: data?.data,
    isLoading,
    isError: error,
  };
}
